import React from 'react';
import { GitMerge, Rocket, Lightbulb, Users, ArrowRight } from 'lucide-react';
import { SERVICE_CARDS } from '../mock';

const iconMap = { GitMerge, Rocket, Lightbulb, Users };

const ServiceCallouts = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="text-center mb-14">
          <p className="eyebrow mb-3">OUR APPROACH</p>
          <h2 className="section-title text-4xl md:text-5xl">Solutions for Every Stage</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICE_CARDS.map((c) => {
            const Icon = iconMap[c.icon];
            return (
              <div key={c.id} className="service-card rounded-xl p-8 flex flex-col">
                <div className="service-icon-wrap mb-6">
                  <Icon size={26} />
                </div>
                <h3 className="service-title text-[#0a2c4d] font-bold text-[15px] tracking-wider mb-3 leading-tight">{c.title}</h3>
                <p className="service-desc text-[#556a85] text-[14px] leading-relaxed mb-6 flex-1">{c.desc}</p>
                <a href="#services" className="inline-flex items-center gap-2 text-[#0a6cb0] font-semibold text-xs uppercase tracking-widest group">
                  Read More <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServiceCallouts;
